export const validateEmail = (email) => {
    const emailRegex = /^\S.*@\S+$/

    return emailRegex.test(email)
}

export const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-zA-Z])(?=.*[0-9])/
    let message = 'okay'
    if(!(passwordRegex.test(password))) message = 'Must contain atleast a number and a letter'
    if(password.length < 8) message = 'Password less than 8 characters'
    return message
}